import { Card, CardContent, Link, Typography } from '@material-ui/core'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'proptypes'

const useStyles = makeStyles((theme) => ({
  root: {
    borderLeft: (props) => (props.large ? 'none' : `2px solid ${theme.colors.grey2}`),
    minHeight: 100,
    height: '100%',
    transition: 'all .25s ease-out',
    borderRadius: (props) => (props.large ? 4 : 8),
    cursor: 'pointer',
    boxShadow: '0 4px 5px 0 rgba(13, 49, 63, 0.05), 0 1px 5px 0 rgba(13, 49, 63, 0.05)',
    textAlign: (props) => (props.alignLeft ? 'left' : 'inherit'),
    minWidth: (props) => (props.large ? 378 : 'auto'),
    margin: (props) => (props.large ? theme.spacing(1) : 'auto'),

    '&:hover': {
      boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)'
    }
  },
  title: {
    fontWeight: 500,
    fontSize: (props) => (props.large ? '1.25rem' : '1.5rem'),
    lineHeight: (props) => (props.large ? '1.2' : '1.5')
  },
  content: {
    fontSize: (props) => (props.large ? '1rem' : '0.875rem'),
    color: (props) => (props.large ? theme.colors.colorTransparent6 : 'inherit'),
    marginTop: (props) => (props.large ? theme.spacing(2) : 0)
  }
}))

function ItemCard(props) {
  const classes = useStyles(props)

  return (
    <Link
      href={props.cta && props.cta.href}
      target={props.cta && props.cta.target}
      rel={props.cta && props.cta.rel}
      title={props.cta && props.cta.title}
      underline="none"
    >
      <Card className={classes.root}>
        <CardContent>
          {props.titleSmall && (
            <Typography variant="h6" gutterBottom>
              {props.titleSmall}
            </Typography>
          )}
          {props.title && (
            <Typography
              className={classes.title}
              variant="h3"
              component="h3"
              gutterBottom
              dangerouslySetInnerHTML={{ __html: props.title }}
            />
          )}
          <Typography
            className={classes.content}
            variant="h5"
            component="div"
            gutterBottom
            dangerouslySetInnerHTML={{ __html: props.content }}
          />
        </CardContent>
      </Card>
    </Link>
  )
}
export default ItemCard

ItemCard.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
    rel: PropTypes.string,
    target: PropTypes.string
  })
}
